// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA6fZj-DAPC39vbeJn3eA5puooOizxwLIk",
  authDomain: "l-essentiel-auxerre.firebaseapp.com",
  projectId: "l-essentiel-auxerre",
  storageBucket: "l-essentiel-auxerre.appspot.com",
  messagingSenderId: "225707877090",
  appId: "1:225707877090:web:596875efad4e181a48b4bb",
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);

export default app;
export const storage = getStorage(app);
